import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@/redux/store.hook';
import { deleteNotification, getNotificationSelector } from '@/redux/notification/notification.slice';

import { Flex } from '@/layout';
import Tabs from '@/components/UI/Tabs';
import NotificationCard from '@/components/Notification/Cards';

import { CardTitle, CardWrapper, ContentWrapper, LinkButton } from '../style';
import { Link } from 'react-router-dom';
import PATH from '@/router/path';
import useResize from '@/hooks/useResize';
import { archiveNotifications } from '@/api/notifications.api';
import { useAppDispatch } from '@/redux/store.hook';

export default function NotificationsCard() {
  // @ts-ignore
  const { t } = useTranslation();
  const {isMobile} = useResize();
  const tabLabel = t('pages.home.notifications.tabs', { returnObjects: true });
  const initTabIndex = 1;
  const [selectedTab, setSelectedTab] = useState<number>(initTabIndex);
  const dispatch = useAppDispatch();
  const notifications = useAppSelector(getNotificationSelector);
  const { notify } = notifications;
  const visibleNotifications = notify.slice(0, 5);
  const archive = async (ids: number[]) => {
    await archiveNotifications(ids);
    dispatch(deleteNotification(ids));
  };

  const tabs: TabsType = [
    {
      label: `${tabLabel[0]} (${visibleNotifications.length})`,
      index: initTabIndex,
      Component: () =>
        visibleNotifications.length !== 0 ? (
          <Flex width={'100%'} flexDirection={'column'} gridGap={'15px'}>
            <NotificationCard data={visibleNotifications} showSelect={false} selectedIds={[]}
              onSelectionChange={() => undefined} onArchive={archive} />
          </Flex>
        ) : (
          <ContentWrapper>
            <span>{t('pages.home.notifications.noData')}</span>
          </ContentWrapper>
        ),
    },
    {
      label: `${tabLabel[1]} (0)`,
      index: 2,
      Component: () => (
        <ContentWrapper>
          <span>{t('pages.home.notifications.noData')}</span>
        </ContentWrapper>
      ),
    },
    {
      label: `${tabLabel[2]} (0)`,
      index: 3,
      Component: () => (
        <ContentWrapper>
          <span>{t('pages.home.notifications.noData')}</span>
        </ContentWrapper>
      ),
    },
  ];

  return (
    <CardWrapper isMobile={isMobile}>
      <CardTitle>
        {t('notifications')}
        <LinkButton>
          <Link to={PATH.home.notifications}>{t('buttons.showAll')}</Link>
        </LinkButton>
      </CardTitle>
      <Tabs tabs={tabs} selectedTab={selectedTab} onClick={setSelectedTab} />
    </CardWrapper>
  );
}
